<script setup lang="ts">
import Footer from "@layouts/sections/footer.vue";
import Header from "@layouts/sections/header.vue";
import DiscountBanner from "@layouts/sections/discount-banner.vue";
import PartnerBanner from "@layouts/sections/partner-banner.vue";
import { usePage } from "@inertiajs/vue3";
import { PagePropsInterface } from "@interfaces/PagePropsInterface.js";
import { onMounted, ref } from "vue";

let page = usePage<PagePropsInterface>();

let showNavBar = ref(true);
let lastScrollPosition = 0;
const navbar = ref<HTMLElement | null>(null);
let container: any | null = null;

onMounted(() => {
    container = document.querySelector(".sidebar");

    const onScroll = () => {
        if (!container) {
            return;
        }

        const currentScrollPosition = container.scrollY || container.scrollTop;

        if (currentScrollPosition === 0 && lastScrollPosition === 0) {
            showNavbar();
            return;
        } else {
            hideNavbar();
        }

        lastScrollPosition = currentScrollPosition;
    };

    const defaultHeight = navbar.value?.offsetHeight || 0;

    const hideNavbar = () => {
        if (!navbar.value) {
            return;
        }

        if (showNavBar.value) {
            for (let i = navbar.value.offsetHeight; i >= 0; i--) {
                setTimeout(
                    ((i) => {
                        return () => {
                            if (navbar.value) {
                                navbar.value.style.height = i + "px";
                            }
                        };
                    })(i),
                    navbar.value.offsetHeight - i
                );
            }
        }
        showNavBar.value = false;
    };

    const showNavbar = () => {
        if (!showNavBar.value) {
            for (let i = 0; i <= defaultHeight; i++) {
                setTimeout(
                    ((i) => {
                        return () => {
                            if (navbar.value) {
                                navbar.value.style.height = i + "px";
                            }
                        };
                    })(i),
                    i
                );
            }
        }
        showNavBar.value = true;
    };

    container?.addEventListener("touchmove", onScroll, { passive: true });
});
</script>
<template>
    <div class="bg-default" id="layout-website-layout">
        <div>
            <div
                ref="navbar"
                :class="{
                    'navbar-hidden': !showNavBar,
                    'navbar-visible': showNavBar,
                }"
            >
                <discount-banner
                    v-if="page.props.discount?.id && !page.props.is_reseller"
                ></discount-banner>
                <partner-banner v-if="page.props.is_reseller"></partner-banner>
                <Header></Header>
            </div>
            <slot />
            <Footer />
        </div>
    </div>
</template>
<style scoped lang="scss">
@use "@scss/layouts/website-layout";
</style>
